import React from 'react';
import DOMPurify from 'dompurify';
import { Text, Space, Title } from '@g2u/ui-kit';

import { SurveySection } from '../survey-section/survey-section.component';
import Geeks2uErrorLogo from 'assets/images/geeks2u-error-logo.svg';
import Geeks2uSuccessLogo from 'assets/images/geeks2u-success-logo.svg';
import styles from './survey-result.module.scss';

export namespace SurveyResult {
  export type Props = {
    title: string;
    description?: string;
    error?: boolean;
  };
  export const $: React.FC<Props> = (props: Props) => {
    const { title, description, error } = props;
    return (
      <SurveySection.$ dataTestId="survey-result-section">
        <Space.$ direction={Space.Direction.Vertical} size={Space.Size.Large}>
          <Space.$
            direction={Space.Direction.Vertical}
            size={Space.Size.ExtraSmall}
            align={Space.Align.Center}
            className={styles.surveyResultSection__header}
            dataTestId="survey-result-section-header"
          >
            <img
              src={error ? Geeks2uErrorLogo : Geeks2uSuccessLogo}
              alt="geeks2u-survey-logo"
              data-testid="survey-result-section-header-logo"
            />
            <Title.$
              level={Title.Level.H1}
              className={styles.surveyResultSection__header}
              dataTestId="survey-result-section-header-text"
            >
              {title}
            </Title.$>
          </Space.$>
          <Space.$ direction={Space.Direction.Vertical} size={Space.Size.ExtraLarge} align={Space.Align.Start}>
            {description && (
              <Text.$ dataTestId="survey-result-section-description-text">
                <div
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(description),
                  }}
                />
              </Text.$>
            )}
            {error && (
              <Text.$ type="secondary" dataTestId="survey-result-section-extra-text">
                If you believe you have reached this message in error, please contact Geeks2U for assistance on 1300 433 572 or via email <a href="mailto:info@geeks2u.com.au">info@geeks2u.com.au</a>
              </Text.$>
            )}
          </Space.$>
        </Space.$>
      </SurveySection.$>
    );
  };
}
